import { Theme, ThemeDetails } from '@yandex-int/k-common/typings';
import { LessonInfo } from 'platform-components';
import React from 'react';

import { MetrikaParams } from 'common.components/hooks/use-prep-lesson-click';

import PromoDescription from './__description/promo__description';
import PromoFilters from './__filters/promo__filters';
import PromoPrepLessons from './__prep-lessons/promo__prep-lessons';
import PromoThemes from './__themes/promo__themes';
import PromoTitle from './__title/promo__title';
import { Filter } from './typings';

interface Props {
    isLoading: boolean;
    themeId: number;
    themeDetails: ThemeDetails | null;
    filterId: number;
    now: Date | null;
    metrikaParams: MetrikaParams;
    filters: Array<Filter>;
    prepLessons: Array<LessonInfo>;
    themes: Array<Theme>;
}

const LibraryPromoPageView = (props: Props) => {
    const { isLoading, themeDetails, filterId, filters, prepLessons, now, themes, metrikaParams } = props;

    const prepLessonMetrikaParams = {
        ...metrikaParams,
        section_block_number: 1,
        section_block_name: '',
    };

    return (
        <>
            <PromoTitle title={themeDetails?.name || ''} />
            <PromoDescription description={themeDetails?.description || ''} />
            <PromoFilters currentFilterId={filterId} filters={filters} metrikaParams={metrikaParams} />
            <PromoPrepLessons
                isLoading={isLoading}
                metrikaParams={prepLessonMetrikaParams}
                now={now}
                prepLessons={prepLessons}
            />
            <PromoThemes metrikaParams={metrikaParams} themes={themes} />
        </>
    );
};

export default LibraryPromoPageView;
